var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1000000975(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 502,
    viewBox: "0 0 750 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2514_42613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 447.384L667 447.384C684.673 447.384 699 433.057 699 415.384L699 79.3842C699 61.7111 684.673 47.3842 667 47.3842L187.043 47.3843C169.37 47.3843 155.043 61.7112 155.043 79.3843L155.043 185.939C155.043 195.075 151.138 203.776 144.312 209.848L61.731 283.311C54.905 289.383 51 298.084 51 307.22L51.0001 415.384C51.0001 433.057 65.3269 447.384 83 447.384Z",
    fill: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 447.384L667 447.384C684.673 447.384 699 433.057 699 415.384L699 79.3842C699 61.7111 684.673 47.3842 667 47.3842L187.043 47.3843C169.37 47.3843 155.043 61.7112 155.043 79.3843L155.043 185.939C155.043 195.075 151.138 203.776 144.312 209.848L61.731 283.311C54.905 289.383 51 298.084 51 307.22L51.0001 415.384C51.0001 433.057 65.3269 447.384 83 447.384Z",
    stroke: "#B43EE9",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2514_42613",
    x: 0.500061,
    y: 0.884277,
    width: 749,
    height: 501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505 0 0 0 0 0.168333 0 0 0 0 0.841667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2514_42613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2514_42613",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000000975);
export default __webpack_public_path__ + "static/media/group-1000000975.85589f27335804b1e24fc7825f79e646.svg";
export { ForwardRef as ReactComponent };